module.exports = __webpack_public_path__ + "static/sydee-49971da7c8f8a3f28db31714f3a799b7.png";